import React, {useState, useEffect} from 'react';
import clsx from 'clsx';
import {isTruthy} from "../../../Utility/logic";
import {hasTeamLeadPowers} from "../../models/Agent";

export default function PayLaterWidget({
  currentAgent, shoppingCart = {}, callbacks
}) {
  let cartProps = shoppingCart?.properties || {};

  const [payLater, setPayLater] = useState(false);

  useEffect(() => {
    setPayLater(isTruthy(cartProps.payLater))
  }, [cartProps])

  if (!hasTeamLeadPowers(currentAgent))
    return null;

  const handleClick = function (e) {
    let val = !payLater;

    if (val) {
      let msg = [
        "If you enable Pay Later, checkout will collect the customer's credit card information ",
        "but not charge the card today. OMS will charge them later. Do this ONLY for pre-authorized ",
        "internal GPC customers!",
        "\n \n",
        "Enable Pay Later, or Cancel?"
      ].join(' ')
      if (!confirm(msg)) {
        //setPayLater(false);
        return true;
      }
    }

    // no need to setPayLater
    callbacks.updateCart({payLater: val});

    return true;
  }

  return <label className="block pl-2 pt-1 font-normal relative text-sm text-white">
    <input type="checkbox" checked={payLater} onChange={handleClick} />
    Enable "Pay Later"
  </label>
}
